import React, { useState } from 'react';
import {
  Checkbox,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../Buttons/ButtonBase';
import { HOURS } from '../../../utils/ConstantsMain';
import ComboText from '../../ComboText';
import { makeStyles } from '@material-ui/core/styles';
import SelectHour from './SelectHour';
import { isMobile, isBrowser } from 'react-device-detect';
import AuthButton from '../../Buttons/AuthButton';

const useStyles = makeStyles(() => ({
  titlesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 668,
    '@media (max-width: 1195px)': {
      display: 'none',
    },
  },
  titleSelects: {
    width: 244,
    fontSize: 14,
    fontWeight: 'bold',
    color: '#484848',
  },
  selectsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 560,
    flexWrap: 'wrap',
    '@media (max-width: 1195px)': {
      width: '100%',
      marginLeft: 40,
    },
  },
  titleSelectMobile: {
    fontSize: 12,
    color: '#484848',
    display: 'none',
    width: 22,
    '@media (max-width: 1195px)': {
      display: 'initial',
    },
  },
  titleForClosed: {
    fontSize: 12,
    color: '#484848',
    display: 'none',
    width: 22,
    '@media (max-width: 1195px) and (min-width: 1132px)': {
      display: 'initial',
    },
    '@media (max-width: 768px) and (min-width: 677px)': {
      display: 'initial',
    },
  },
  flexAlignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  divClosed: {
    width: 244,
    height: 48,
    backgroundColor: '#f5f5f5',
    color: '#969696',
    display: 'flex',
    margin: '8px 10px 10px',
    '@media (max-width: 1131px) and (min-width:769px)': {
      marginLeft: 28,
    },
    '@media (max-width: 676px)': {
      marginLeft: 28,
    },
  },
  divClosedHidden: {
    width: 244,
    height: 48,
    backgroundColor: '#f5f5f5',
    color: '#969696',
    display: 'flex',
    margin: '8px 10px 10px',
    '@media (max-width: 1131px) and (min-width:769px)': {
      display: 'none',
    },
    '@media (max-width: 676px)': {
      display: 'none',
    },
  },
}));

const weekDays = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo',
];

const ScheduleDivided = ({
  values,
  typeSchedule,
  handleSubmit,
  touched,
  errors,
  handleBlur,
  setFieldValue,
  handleChange,
  handleCancel,
  isValid,
  resetForm,
  flagEdit,
  props,
}) => {
  const classes = useStyles();

  const handleTagSelect = (field) => (value) => {
    setFieldValue(field, value);
  };

  const handleCheckBox = (field) => (event) => {
    let value = { ...values[event.target.value] };
    value = {
      ...value,
      open: !value.open,
    };

    setFieldValue(field, value);
  };

  const handleSelectHour = (weekDay, hours, shift) => {
    let value = { ...values[weekDay] };
    value[shift] = {
      ...value[shift],
      start: hours.start,
      end: hours.end,
    };
    setFieldValue(weekDay, value);
  };

  return (
    <>
      <form>
        {isBrowser && (
          <div className={classes.titlesContainer}>
            <span
              className={classes.titleSelects}
              style={{
                marginLeft: 130,
              }}
            >
              Matutino
            </span>
            <span className={classes.titleSelects}>Vespertino</span>
          </div>
        )}

        {weekDays.map((day, index) => (
          <div key={index} style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: 116,
              }}
            >
              <Checkbox
                name={day}
                id={day}
                checked={values[day].open}
                onChange={handleCheckBox(day)}
                value={day}
                color="secondary"
              />

              <span style={{ color: '#484848' }}>{day}</span>
            </div>
            <>
              {values[day].open ? (
                <div className={classes.selectsContainer}>
                  <div className={classes.flexAlignCenter}>
                    <span className={classes.titleSelectMobile}>Mat</span>
                    <SelectHour
                      weekDay={day}
                      indexDay={index}
                      handleSelectHour={handleSelectHour}
                      start={values[day].morning.start}
                      end={values[day].morning.end}
                      shift="morning"
                    />
                  </div>
                  <div className={classes.flexAlignCenter}>
                    <span className={classes.titleSelectMobile}>Ves</span>
                    <SelectHour
                      weekDay={day}
                      indexDay={index}
                      handleSelectHour={handleSelectHour}
                      start={values[day].morning.end === '24:00'? '' : values[day].evening.start}
                      end={values[day].morning.end === '24:00'? '' : values[day].evening.end}
                      morningEnd={values[day].morning.end}
                      shift="evening"
                    />
                  </div>
                </div>
              ) : (
                <div className={classes.selectsContainer}>
                  <div className={classes.flexAlignCenter}>
                    <span className={classes.titleSelectMobile}>Mat</span>
                    <div className={classes.divClosed}>
                      <span style={{ margin: 'auto' }}>Cerrado</span>
                    </div>
                  </div>
                  <div className={classes.flexAlignCenter}>
                    <span className={classes.titleForClosed}>Ves</span>
                    <div className={classes.divClosedHidden}>
                      <span style={{ margin: 'auto' }}>Cerrado</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          </div>
        ))}
        <div style={{ display: 'flex', marginTop: 18, width: '100%' }}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            style={{ marginRight: 24, minWidth: isMobile ? 144 : 160, padding: isMobile ? '0 7px' : 'inherit' }}
          >
            Guardar cambios
          </ButtonBase>
          <AuthButton
            variant="outlinedBlue"
            onClick={(e) => {
              handleCancel(e);
              !flagEdit && resetForm();
            }}
            style={{
              width: isMobile ? 144 : 160,
              display: flagEdit || isValid ? 'initial' : 'none',
            }}
          >
            Cancelar
          </AuthButton>
        </div>
      </form>
    </>
  );
};

export default ScheduleDivided;
